import { motion } from "framer-motion";
import React, { useState } from "react";
import "../../styles/Level.css";
import Card from "./Card";

const containerLevel = {
  hidden: {
    opacity: 0,
    x: "100vh",
  },
  visible: {
    opacity: 1,
    x: "0",
    transition: {
      type: "spring",
      stiffness: 120,
    },
  },
  hov: {
    scale: 1.05,
  },
};

const Level = ({ item }) => {
  const [seeMore, setSeeMore] = useState(false);
  return (
    <motion.div
      className="level"
      variants={containerLevel}
      initial="hidden"
      animate="visible"
    >
      <h1 className="level-title-bold">
        Level <span className="level-red">{item._id}</span>
      </h1>
      <div className="cards d-flex justify-content-start">
        {seeMore
          ? item.courses.map((course, index) => (
              <Card course={course} key={index} />
            ))
          : item.courses
              .slice(0, 4)
              .map((course, index) => <Card course={course} key={index} />)}
      </div>
      <div className="level-more-btn">
        <motion.button
          className="contButCourse"
          variants={containerLevel}
          whileHover="hov"
          onClick={() => setSeeMore(!seeMore)}
        >
          {seeMore ? "Less" : "More"}
        </motion.button>
      </div>
    </motion.div>
  );
};

export default Level;
